import { render, staticRenderFns } from "./ViewVacationSubmitted.vue?vue&type=template&id=6dbb61a1"
import script from "./ViewVacationSubmitted.vue?vue&type=script&lang=ts"
export * from "./ViewVacationSubmitted.vue?vue&type=script&lang=ts"
import style0 from "./ViewVacationSubmitted.vue?vue&type=style&index=0&id=6dbb61a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports